// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { ContentChild } from "@angular/core";

export const environment = {
  production: false,
};

export const content_api_url= "https://cdn.contentful.com/spaces/gh3j6s0dbkbp/environments/master";
export const content_api_token= "TXCQMbSgUdQWTLOFFH2Z-83ElU0FLBV6E9T4knO5dls";


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
